/* eslint-disable import/no-anonymous-default-export */
import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { pages, videoPages } from "../../constants/PagePaths";
import "./myPage.scss";
import { videoApi } from "../../config/videoApi";
import { api } from "../../config/api";
import AlertContext from "../../contexts/AlertContext";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

interface Props {}

export default () => {
  const alertContext = useContext(AlertContext);
  const [isLogin, setIsLogin] = useState(true);
  const [myPurchase, setMyPurchase] = useState([]);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const inputStarRef = useRef<any>(null);
  const inputReviewRef = useRef<any>(null);
  const history = useHistory();
  const alreadyWriteReviewRef = useRef<any>(null);
  const [alreadyWriteReviewRating, setAlreadyWriteReviewRating] = useState(0);
  const [state, setState] = useState(0);
  const [userInfo, setUserInfo] = useState<any>(null);

  useEffect(() => {
    new Promise(async () => {
      if (isLogin) {
        const myDataRes = await videoApi.getMyCourseAsync();
        const purchaseData = await (
          await videoApi.getMyCourseAsync()
        ).data.user_video_purchases;
        // console.log(myDataRes);
        // console.log(purchaseData);

        setMyPurchase(purchaseData);
        
        // 사용자 정보 가져오기
        try {
          const userRes = await api.getMyInfo();
          setUserInfo(userRes.data);
        } catch (error) {
          console.error('Failed to get user info:', error);
        }
      }
    });
    var $star_rating: any = $(".star-rating .fa");

    var SetRatingStar = function () {
      return $star_rating.each(function () {
        if (
          parseInt($star_rating.siblings("input.rating-value").val()) >=
          parseInt($(this).data("rating"))
        ) {
          return $(this).removeClass("fa-star-o").addClass("fa-star");
        } else {
          return $(this).removeClass("fa-star").addClass("fa-star-o");
        }
      });
    };

    $star_rating.on("click", function (e) {
      if (!e.target.parentNode.classList.value.includes("disabled")) {
        $star_rating.siblings("input.rating-value").val($(this).data("rating"));
        return SetRatingStar();
      }
    });

    // SetRatingStar();
  }, [state]);

  const refresh = () => {
    setState(state + 1);
  };

  const generateCertificate = async (course: any) => {
    // 사용자 정보가 없으면 다시 가져오기
    let currentUserInfo = userInfo;
    if (!currentUserInfo) {
      try {
        const userRes = await api.getMyInfo();
        currentUserInfo = userRes.data;
        setUserInfo(currentUserInfo);
      } catch (error) {
        console.error('Failed to get user info:', error);
        alertContext.showAlert("사용자 정보를 불러올 수 없습니다.");
        return;
      }
    }

    // 수강 시작일과 현재 날짜 계산
    const startDate = new Date(course.started_at);
    const endDate = new Date(course.expire_date);
    const currentDate = new Date();
    let daysPassed = Math.floor((currentDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
    const totalDays = 90; // 수강 기간은 항상 90일
    
    // 수강완료율이 전체 수강 기간을 넘지 않도록 제한
    if (daysPassed > totalDays) {
      daysPassed = totalDays;
    }
    
    const completionRate = `${daysPassed}일`; // 일수로 표시

    // PDF 생성을 위한 임시 div 생성
    const certificateDiv = document.createElement('div');
    certificateDiv.style.width = '210mm';
    certificateDiv.style.height = '297mm';
    certificateDiv.style.padding = '40mm 30mm';
    certificateDiv.style.backgroundColor = 'white';
    certificateDiv.style.position = 'absolute';
    certificateDiv.style.left = '-9999px';
    certificateDiv.style.fontFamily = '"Malgun Gothic", "맑은 고딕", sans-serif';

    certificateDiv.innerHTML = `
      <div style="position: relative; height: 100%;">
        <!-- 로고 왼쪽 상단 -->
        <div style="position: absolute; top: -20mm; left: 0;">
          <span style="
            color: #1a73e8;
            font-size: 40px;
            font-family: 'Tenada', 'Arial', sans-serif;
          ">콘엑스</span>
        </div>
        
        <!-- 문서번호 오른쪽 상단 -->
        <div style="position: absolute; top: -20mm; right: 0; text-align: right;">
          <p style="font-size: 12px; color: #666; margin: 0;">문서번호: CON-${currentDate.getFullYear()}${String(currentDate.getMonth() + 1).padStart(2, '0')}${String(currentDate.getDate()).padStart(2, '0')}-${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}</p>
          <p style="font-size: 12px; color: #666; margin: 0;">발행일자: ${currentDate.getFullYear()}년 ${currentDate.getMonth() + 1}월 ${currentDate.getDate()}일</p>
        </div>
        
        <div style="text-align: center; height: 100%; display: flex; flex-direction: column;">
          <!-- 제목 -->
          <div style="margin-top: 20mm;">
            <h1 style="font-size: 42px; margin-bottom: 40px; font-weight: bold; letter-spacing: 8px;">수 강  증 명 서</h1>
          </div>
          
          <!-- 내용 -->
          <div style="margin-top: 20px; text-align: center;">
            <table style="margin: 0 auto; border-collapse: collapse; width: 80%; font-size: 16px;">
              <tr>
                <td style="width: 30%; padding: 15px; border-top: 2px solid #333; border-bottom: 1px solid #ddd; background-color: #f8f8f8; font-weight: bold;">성명</td>
                <td style="width: 70%; padding: 15px; border-top: 2px solid #333; border-bottom: 1px solid #ddd;">${currentUserInfo.last_name || currentUserInfo.username || '사용자'}</td>
              </tr>
              <tr>
                <td style="padding: 15px; border-bottom: 1px solid #ddd; background-color: #f8f8f8; font-weight: bold;">수료 과정</td>
                <td style="padding: 15px; border-bottom: 1px solid #ddd;">${course.title}</td>
              </tr>
              <tr>
                <td style="padding: 15px; border-bottom: 1px solid #ddd; background-color: #f8f8f8; font-weight: bold;">수강 완료율</td>
                <td style="padding: 15px; border-bottom: 1px solid #ddd;">${completionRate}</td>
              </tr>
              <tr>
                <td style="padding: 15px; border-bottom: 2px solid #333; background-color: #f8f8f8; font-weight: bold;">수강일</td>
                <td style="padding: 15px; border-bottom: 2px solid #333;">${totalDays}일</td>
              </tr>
            </table>
          </div>
          
          <!-- 증명 문구 -->
          <div style="margin-top: 60px; text-align: center;">
            <p style="font-size: 20px; line-height: 1.8; margin-bottom: 80px;">
              위 사람은 콘엑스의 ${course.title} 과정에서<br/>
              성실하게 수강하였음을 증명합니다.
            </p>
          </div>
          
          <!-- 하단 서명 -->
          <div style="margin-top: auto; text-align: center; padding-bottom: 20mm;">
            <p style="font-size: 18px; margin-bottom: 50px;">${currentDate.getFullYear()}년 ${currentDate.getMonth() + 1}월 ${currentDate.getDate()}일</p>
            <div style="position: relative; display: inline-block;">
              <p style="font-size: 26px; font-weight: bold; letter-spacing: 3px;">(주) 뚜 껑</p>
              <img src="/images/icons/corporate-seal.png" style="position: absolute; width: 45px; height: 45px; right: -50px; top: 0px; opacity: 0.9;" />
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(certificateDiv);

    try {
      // HTML을 canvas로 변환
      const canvas = await html2canvas(certificateDiv, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff'
      });

      // Canvas를 PDF로 변환
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save(`수강증명서_${course.title}_${currentUserInfo.last_name || '사용자'}.pdf`);
      
      alertContext.showAlert("수강증명서가 다운로드되었습니다.");
    } catch (error) {
      console.error('PDF 생성 중 오류:', error);
      alertContext.showAlert("PDF 생성 중 오류가 발생했습니다.");
    } finally {
      document.body.removeChild(certificateDiv);
    }
  };

  const writeReview = async () => {
    if (inputStarRef.current && inputReviewRef.current) {
      const rating = inputStarRef.current.value;
      // selectedVideoId;
      const review = inputReviewRef.current.value;
      if (review.length < 1) {
        alertContext.showAlert("리뷰 내용을 입력해주세요.");
        return;
      }
      if (rating > 5 || rating < 1) {
        alertContext.showAlert("리뷰 점수를 확인해주세요.");
        return;
      }
      const res = await videoApi.postReview(
        selectedVideoId!,
        review,
        parseInt(rating)
      );
      if (res.data.code === 1) {
        alertContext.showAlert("리뷰가 등록되었습니다.", () => {
          $("#reviewModal").modal("hide");
        });
      } else {
        alertContext.showAlert("등록에 실패하였습니다.", () => {
          inputReviewRef.current.value = "";
          inputStarRef.current.value = 1;
          $("#reviewModal").modal("hide");
          // window.location.reload();
        });
      }
      refresh();
    }
  };

  // 현재 날짜를 yyyy-mm-dd 형식으로 가져오는 함수
  function getCurrentDateString() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // 월은 0부터 시작하므로 1을 더합니다.
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  // 날짜 문자열을 비교하는 함수
  function isExpired(dateString: string) {
    const today = new Date(getCurrentDateString());
    const inputDate = new Date(dateString);

    return inputDate < today;
  }

  return (
    <>
      <section className="content">
        <h3>나의 강의장</h3>
        <div
          className="video-list aos-init aos-animate"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          {myPurchase
            .sort((a: any, b: any) => {
              // 수강기간이 남은 강의를 먼저 표시
              const aExpired = isExpired(a.expire_date);
              const bExpired = isExpired(b.expire_date);
              
              if (aExpired && !bExpired) return 1; // a가 만료, b가 활성 -> b를 앞으로
              if (!aExpired && bExpired) return -1; // a가 활성, b가 만료 -> a를 앞으로
              
              // 둘 다 같은 상태면 종료일 기준으로 정렬 (가까운 순)
              return new Date(a.expire_date).getTime() - new Date(b.expire_date).getTime();
            })
            .map((course: any) => {
            return (
              <div
                className={
                  isExpired(course.expire_date)
                    ? "video-list-item list-disabled bg-white"
                    : "video-list-item bg-white"
                }
                key={course.id}
              >
                <a>
                  <div
                    className="img-wrap"
                    onClick={() => {
                      history.push(`${videoPages.curriculum}/${course.id}`);
                    }}
                  >
                    <img src={course.card_image} />
                  </div>
                  <div className="flex-2">
                    <div className="title-lg">{course.title}</div>
                    <div className="caption">{course.description}</div>
                    <div className="border-1"></div>
                    <div className="list-style-sm">
                      <ul className="list-group">
                        <li className="list-group-item">
                          <div className="title">시작일</div>
                          <div className="body">{course.started_at}</div>
                        </li>
                        <li className="list-group-item">
                          <div className="title">종료일</div>
                          <div className="body">
                            <div className="body text-danger">
                              {course.expire_date}
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    {isExpired(course.expire_date) ? (
                      <button
                        type="button"
                        className="btn btn-md btn-primary-soft w-100"
                        disabled
                      >
                        종료된 강의
                      </button>
                    ) : course.last_viewed_video ? (
                      <button
                        type="button"
                        className="btn btn-md btn-primary-soft w-100"
                        onClick={() => {
                          history.push(
                            videoPages.course + "/" + course.last_viewed_video
                          );
                        }}
                      >
                        이어서 듣기
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-md btn-primary w-100"
                        onClick={() => {
                          history.push(videoPages.curriculum + "/" + course.id);
                        }}
                      >
                        시작하기
                      </button>
                    )}
                  </div>
                </a>
                <div className="review-btn-wrap">
                  {course.review ? (
                    <button
                      type="button"
                      className="btn btn-md btn-outline review-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#reviewDetailModal"
                      onClick={() => {
                        alreadyWriteReviewRef.current.value =
                          course.review.review;
                        setAlreadyWriteReviewRating(course.review.rating);
                      }}
                    >
                      내가 쓴 리뷰 확인하기
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-md btn-outline review-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#reviewModal"
                      onClick={() => {
                        setSelectedVideoId(course.id);
                      }}
                    >
                      리뷰쓰기
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-md btn-primary review-btn mt-2"
                    onClick={() => generateCertificate(course)}
                  >
                    수강 증명서 출력
                  </button>
                </div>
              </div>
            );
          })}
        </div>
        {myPurchase.length == 0 ? (
          <div
            className="section-empty aos-init"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <img src="/images/ddusul/3d-danger.png" />
            <p>내용이 없습니다.</p>
          </div>
        ) : (
          ""
        )}
      </section>
      <div
        className="modal fade"
        id="reviewDetailModal"
        tabindex="-1"
        aria-labelledby="reviewDetailModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="reviewDetailModalLabel">
                강의는 어떠셨나요?
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <label className="fw-bold">평점</label>
              <div className="star-rating mb-4 disabled">
                {Array.from({ length: 5 }).map((_, index) => (
                  <span
                    className={
                      index + 1 > alreadyWriteReviewRating
                        ? "fa fa-star-o"
                        : "fa fa-star"
                    }
                    data-rating={index + 1}
                  ></span>
                ))}
                <input
                  type="hidden"
                  name="whatever1"
                  className="rating-value"
                  readOnly
                  value={alreadyWriteReviewRating}
                />
              </div>
              <label className="fw-bold">내용</label>
              <textarea
                className="form-control"
                aria-label="With textarea"
                ref={alreadyWriteReviewRef}
                readOnly
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="reviewModal"
        tabIndex={-1}
        aria-labelledby="reviewModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="reviewModalLabel">
                강의는 어떠셨나요?
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <label className="fw-bold">평점</label>
              <div className="star-rating mb-4">
                <span className="fa fa-star" data-rating="1"></span>
                <span className="fa fa-star" data-rating="2"></span>
                <span className="fa fa-star" data-rating="3"></span>
                <span className="fa fa-star" data-rating="4"></span>
                <span className="fa fa-star" data-rating="5"></span>
                <input
                  type="hidden"
                  name="whatever1"
                  className="rating-value"
                  value="5"
                  ref={inputStarRef}
                />
              </div>
              <label className="fw-bold">내용</label>
              <textarea
                className="form-control"
                aria-label="With textarea"
                ref={inputReviewRef}
              ></textarea>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  writeReview();
                }}
              >
                작성완료
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
